<span>
  <span>{{ getRechtsgueltigCount() }}</span>
  /
  <span
    [style.text-decoration]="canReadHistorisch() && personRolleCount.historischCount > 0 ? 'line-through' : 'none'"
    style="color: red"
    >{{ getHistorischCount() }}</span
  >
</span>
